import React from 'react';

/**
 * Компонент выбора секции для навигации
 * Отображает список секций с заголовками или типами
 */
export default function SectionSelect({
  value,
  onChange,
  allSections = [],
  placeholder = 'Выберите секцию',
  allowCustom = true,
  className = ''
}) {
  // Хелпер для получения текста из строки или объекта
  const getTextValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object' && value !== null) {
      return value.text || '';
    }
    return value;
  };

  // Получить отображаемое имя секции
  const getSectionLabel = (section, index) => {
    // Пробуем найти заголовок в контенте
    const rawTitle = section?.content?.title
      || section?.content?.sectionTitle
      || section?.content?.heading
      || section?.content?.formTitle;

    const title = getTextValue(rawTitle);

    if (title && title.trim()) {
      return `${index + 1}. ${title}`;
    }

    // Если заголовка нет - используем имя секции или тип
    return `${index + 1}. ${section?.name || section?.type || 'Секция'}`;
  };

  // Определить текущий выбор
  const getCurrentSelection = () => {
    if (!value) return '';

    // Если это ссылка на секцию (#section-X)
    if (value.startsWith('#section-')) {
      return value;
    }

    // Если это внешняя ссылка
    return 'custom';
  };

  const currentSelection = getCurrentSelection();
  const isCustomLink = value && !value.startsWith('#section-') && value !== '';

  const handleChange = (e) => {
    const selected = e.target.value;

    if (selected === 'custom') {
      // Пользователь хочет ввести свою ссылку
      onChange('');
    } else if (selected === '') {
      onChange('');
    } else {
      onChange(selected);
    }
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <select
        value={isCustomLink ? 'custom' : currentSelection}
        onChange={handleChange}
        className="w-full px-3 py-2 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-base md:text-sm"
      >
        <option value="">{placeholder}</option>

        {allSections.map((section, index) => (
          <option key={section?.id || index} value={`#section-${index}`}>
            {getSectionLabel(section, index)}
          </option>
        ))}

        {allowCustom && (
          <option value="custom">Внешняя ссылка...</option>
        )}
      </select>

      {/* Поле для внешней ссылки */}
      {isCustomLink && (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://example.com"
          className="w-full px-3 py-2 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-base md:text-sm"
        />
      )}
    </div>
  );
}
